// Italian copy table. Flat map keyed by dotted path. Resolves
// placeholders like {email} from the second argument.
const messages = {
  'app.tagline': 'Pannello di gestione',

  'login.title': 'Bentornato',
  'login.subtitle': 'Accedi al pannello per continuare',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.submit': 'Continua',
  'login.submitting': 'Accesso in corso...',
  'login.forgot': 'Password dimenticata?',
  'login.or': 'oppure',
  'login.passkey': 'Accedi con una passkey',
  'login.passkeyHint': 'Usa la biometria o la chiave di sicurezza del dispositivo, senza password.',
  'login.passkey.busy': 'Verifica della passkey...',
  'login.passkey.cancelled': 'Operazione annullata.',
  'login.passkey.failed': 'Passkey non riconosciuta o non valida.',
  'login.passkey.unsupported': 'Questo dispositivo non supporta le passkey.',
  'login.error.generic': 'Impossibile accedere. Riprova.',
  'login.error.invalid': 'Email o password non corrette.',
  'login.error.locked': 'Account temporaneamente bloccato. Riprova tra qualche minuto.',
  'login.error.maintenance': 'Servizio in manutenzione. Riprova a breve.',

  'mfa.title': 'Verifica in due passaggi',
  'mfa.subtitle': 'Inserisci il codice generato dall\'app di autenticazione',
  'mfa.code': 'Codice a 6 cifre',
  'mfa.submit': 'Verifica',
  'mfa.submitting': 'Verifica in corso...',
  'mfa.error.invalid': 'Codice non valido o scaduto.',

  'common.logout': 'Esci',
  'common.loading': 'Caricamento...',
  'common.error': 'Errore',
  'common.retry': 'Riprova',
  'common.cancel': 'Annulla',
  'common.confirm': 'Conferma',
  'common.save': 'Salva',
  'common.search': 'Cerca',
  'common.notFound': 'Pagina non trovata',
  'common.back': 'Torna indietro',
  'common.unauthorized': 'Non autorizzato',

  'nav.dashboard': 'Dashboard',
  'nav.users': 'Utenti',
  'nav.roles': 'Ruoli',
  'nav.stores': 'Negozi',
  'nav.products': 'Prodotti',
  'nav.categories': 'Categorie',
  'nav.ai': 'AI',
  'nav.aiPersonality': 'Personalità',
  'nav.aiPlayground': 'Playground',
  'nav.aiUsage': 'Consumi',
  'nav.rag': 'Knowledge base',
  'nav.privacy': 'Privacy',
  'nav.analytics': 'Analytics',
  'nav.logs': 'Log',
  'nav.settings': 'Impostazioni',
  'nav.system': 'Sistema',

  'dashboard.title': 'Dashboard',
  'dashboard.welcome': 'Benvenuto, {name}.',
  'dashboard.placeholder': 'La dashboard sarà popolata nello sprint successivo.'
};

export function t(key, vars) {
  const raw = messages[key];
  if (raw === undefined) return key;
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, name) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : `{${name}}`
  );
}
